<template>
  <!-- prettier-ignore -->
  <div>
    <basic-text-input
      v-model="date"
      inputmode="decimal"
      manual-validation
      type="text"
      :disabled="$props.disabled"
      :mask="'##.##.####'"
      :name="$props.name"
      :placeholder="$props.placeholder"
      :label="$props.label"
      :v="$props.v"
      @blur="handleBlur"
    >
      <template #leading>
        <slot name="leading" />
      </template>

      <template #trailing>
        <slot name="trailing" />
      </template>
    </basic-text-input>
  </div>
</template>

<script setup>
import { watch, watchEffect } from 'vue'

import { DateTimeUtil } from '@/utils/DateTime'

import BasicTextInput from '@/components/Basic/TextInput'

import { DATE_FORMAT_DIN, DATE_FORMAT_ISO } from '@/config/constants'

// INIT
const date = defineModel('date', { type: String })
const model = defineModel({ type: [String, Number] })

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },

  name: {
    type: String,
    required: true,
  },

  label: {
    type: String,
    required: true,
  },

  placeholder: {
    type: [String],
    default: '',
  },

  v: {
    type: Object,
    default: () => {},
  },
})

// METHODS
function handleBlur() {
  if (date.value?.length !== 10) {
    model.value = null
  }
}

// WATCHERS
watch(
  () => date.value,
  (newValue, oldValue) => {
    if (newValue === null) {
      // model has been cleared in textinput, therefore clear the model here as well
      model.value = null
    }

    if (newValue?.length === 10) {
      try {
        model.value = DateTimeUtil.formatDate(newValue, DATE_FORMAT_ISO)
      } catch {
        date.value = null
      }

      if (oldValue !== undefined) {
        props.v.$validate()
      }
    }
  }
)

watchEffect(() => {
  if (model.value) {
    date.value = DateTimeUtil.formatDate(model.value, DATE_FORMAT_DIN)
  }
})
</script>
